import { AppNavigation } from '@euler/app/components/AppNavigationProvider';
import { AiAgentBundleId } from '@euler/model/ai-home';
import { AiAttachmentInfo } from '@euler/model/apdm';
import type { AiChatTap } from './conversation';
import { AiSuiteTool } from './theme';

export interface AiChatFirstMessage {
  text: string;
  attachments: AiAttachmentInfo[];
  /** Sent with the text, e.g. the case picked to practise. */
  tap?: AiChatTap;
}

export type AiChatOpenTarget =
  | { kind: 'session'; sessionId: string; bundleId?: AiAgentBundleId }
  | {
      kind: 'new';
      tool: AiSuiteTool | null;
      bundleId?: AiAgentBundleId;
      message?: AiChatFirstMessage;
    };

export type AiChatStart = Extract<AiChatOpenTarget, { kind: 'new' }>;

// A prompt and its attachments are not URL material, so the route carries
// only a request id and the chat page takes the start from here once.
const pendingStarts = new Map<string, AiChatStart>();

export function takeAiChatStart(
  requestId: string | undefined,
): AiChatStart | null {
  if (!requestId) return null;
  const start = pendingStarts.get(requestId) ?? null;
  pendingStarts.delete(requestId);
  return start;
}

export function openAiChat(
  navigation: AppNavigation,
  target: AiChatOpenTarget,
) {
  if (target.kind === 'session') {
    navigation.navigate('AiChat', {
      sessionId: target.sessionId,
      bundleId: target.bundleId,
    });
    return;
  }
  const requestId = `${Date.now()}`;
  pendingStarts.set(requestId, target);
  navigation.navigate('AiChat', { requestId });
}
